import React from "react";
import ReactSwitch from "react-switch";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
    setActiveAggregator,
    setAssignRowsItem,
    store,
} from "../store";
import { useSnapshot } from "valtio";

type CustomIconsAssociateModalType = {
    element: any;
    selectedAggregator: any;
    isOneShopClicked: boolean;
};

export function CustomIconsAssociateModal({
    element,
    isOneShopClicked,
    selectedAggregator,
}: CustomIconsAssociateModalType) {
    const { assignRows } = useSnapshot(store);
    const { t } = useTranslation();
    const [aggregatorState, setAggregatorState] = React.useState<boolean>(
        isOneShopClicked === true &&
            selectedAggregator.findIndex(
                (el: any) => el.Id === element.selectedRow.Id
            ) !== -1
            ? selectedAggregator[
                  selectedAggregator.findIndex(
                      (el: any) => el.Id === element.selectedRow.Id
                  )
              ].isActive
            : true
    );
    React.useEffect(() => {
        const index = assignRows.findIndex(
            (item: any) => item["Id"] === element.selectedRow.Id
        );
        setAssignRowsItem(index, {
            ...assignRows[index],
            state: aggregatorState,
            stateShop: aggregatorState,
            isActive: aggregatorState,
        });
        // eslint-disable-next-line
    }, [aggregatorState]);

    React.useEffect(() => {
        setActiveAggregator({
            Id: element.selectedRow.Id,
            state: aggregatorState,
        });
        // eslint-disable-next-line
    }, [aggregatorState]);

    return (
        <React.Fragment>
            {element.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around fed_icn_AFenableDisable">
                    <Tooltip
                        title={
                            aggregatorState === false
                                ? t("Activate")
                                : t("Unactivate")
                        }
                    >
                        <div>
                            <ReactSwitch
                                className="agr_icn_AFenableDisable"
                                uncheckedIcon={false}
                                checkedIcon={false}
                                handleDiameter={26}
                                offColor="#f7b4b8"
                                offHandleColor="#E30613"
                                checked={aggregatorState}
                                onChange={() => {
                                    setAggregatorState(!aggregatorState);
                                    // setSelectedRowsAggregator(element);
                                }}
                                onColor="#c2eddd"
                                onHandleColor="#34C38F"
                                width={50}
                                height={20}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
